import React from 'react';
import AnalyticsDashboard from '../../components/Analytics';

const Analytics = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AnalyticsDashboard />
    </div>
  );
};

export default Analytics;